import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// Registering is a side effect, not a render, so guarding it here keeps the
// server import safe without ever diverging server and client markup.
if (typeof window !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger)
}

// One shared easing vocabulary, so every section moves with the same feel.
export const ease = {
    out: 'cubic-bezier(0.16, 1, 0.3, 1)',
    expo: 'expo.out',
    power: 'power3.out',
    power4: 'power4.out',
    inOut: 'power2.inOut'
} as const

export const duration = {
    fast: 0.45,
    base: 0.9,
    slow: 1.3,
    reveal: 1.5
} as const

export { gsap, ScrollTrigger }
